import { service } from '.';

export default {
  upload: (query, data) => service.post(query, data),
  download: (query) => service.get(query),
};
